import { render, staticRenderFns } from "./checkboxlist.vue?vue&type=template&id=825ba6cc"
import script from "./checkboxlist.vue?vue&type=script&lang=js"
export * from "./checkboxlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports